import React, { useRef } from 'react'
import { Modal } from './Modal.jsx'
import { Button } from '../Button/Button.jsx'

/**
 * Confirmation dialog. Built on top of <Modal>. For destructive confirms,
 * pass `tone="danger"` — the confirm button switches to the danger variant
 * and Cancel becomes the autofocused (safer-default) initial focus.
 *
 * Props:
 *   - open, onConfirm, onCancel
 *   - title, message
 *   - confirmLabel (default "Confirm"), cancelLabel (default "Cancel")
 *   - tone: 'default' | 'danger'
 */
export function ConfirmDialog({
  open,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'default',
}) {
  const cancelRef = useRef(null)
  const isDanger = tone === 'danger'
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      width="sm"
      nested
      initialFocusRef={isDanger ? cancelRef : undefined}
    >
      {message ? <p style={{ margin: 0, lineHeight: 1.5 }}>{message}</p> : null}
      <div className="modal__actions">
        <Button ref={cancelRef} variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button
          variant={isDanger ? 'danger' : 'primary'}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  )
}
